import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useGlobalName from '@hooks/useGlobalName';
import { ItemRow } from '@models/item';
import { Fragment } from 'react';

interface Props {
    item: ItemRow;
}

function ItemText({ item }:Props) {
    const {
        salePrice, name, nameEn, nameKo, nameJa,
    } = item;
    const itemName = useGlobalName({
        nameKo, name, nameEn, nameJa,
    });
    const priceUnit = usePriceUnit();
    return (
        <Column align='center'>
            <NameText as='div' size='body-long' align='center'>
                {itemName}
            </NameText>
            <Text size='title' fontWeight='bold'>
                {salePrice.toLocaleString()}{priceUnit}
            </Text>
        </Column>
    );
}

const NameText = styled(Text)`
    white-space: pre-wrap;
    overflow: hidden;
`;

export default ItemText;
